






































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import GoodSelect from '@/components/goods-select/index.vue'
import OutfitApi from '@/api/goods/outfitlist/index'
import PicModal from '@/components/upload/picModal.vue'
import OutfitClassifyApi from '@/api/goods/outfitClassify/index'
import MainPicture from '@/components/upload/mainPicture.vue'
@Component({
  components: {
    GoodSelect,
    PicModal,
    MainPicture
  },
})
export default class OutfixProduct extends Vue {
  groupList: any[] = []
  outfitsDetail: any = {
    outfitPrice: null,
    name: '',
    // code: '',
    pictureUrl: '',
    groupId: '',
    isOpen: false,
    mainImage: '',
    frameId: '',
    // promotionOutfitId: '',
    promotionOutfitProducts: [],
    startTime: null,
    endTime: null,
    isTemporary: false
  }
  columns = [
    {
      title: '商品名称',
      key: 'productName',
    },
    {
      title: '图片',
      key: 'pictureUrl',
      slot: 'pictureUrl',
      // width: 100,
    },
    {
      title: '款号',
      key: 'productCode',
      // width: 160,
    },
    {
      title: '操作',
      key: 'action',
      slot: 'action',
      // width: 120,
    },
  ]
  validateEndTime = (rule, value, callback) => {
      if(this.outfitsDetail.startTime && value && value < this.outfitsDetail.startTime){
        callback(new Error('结束时间不能早于开始时间'));
      }
      else{
        callback();
      }
  }
  ruleForm = {
    pictureUrl: [{ required: true, message: '请选择套装图', trigger: 'blur,change' }],
    name: [{ required: true, message: '请输入套装名称', trigger: 'blur' }],
    // code: [{ required: true, message: '请输入套装编号', trigger: 'blur' }],
    outfitPrice: [{ required: true, type: 'number', message: '请输入套装价格', trigger: 'blur' }],
    groupId: [{ required: true, message: '请选择套装分组', trigger: 'change' }],
    endTime:[{ validator: this.validateEndTime, trigger:'blur' }]
  }
  mounted() {
    let { id } = this.$route.params
    if (id) {
      this.getOutfitDetail(id.toString())
    }
    this.getGroupList()
  }
  /**
   * 选择图片
   */
  picChangeMain(e) {
    this.outfitsDetail.mainImage = e[0].frameUrl
    this.outfitsDetail.frameId = e[0].id
  }
  getOutfitDetail(id: string) {
    OutfitApi.getProductOutfitDetial(id).then((res) => {
      console.log('套装详情', res)
      res.data.startTime = new Date(res.data.startTime)
      res.data.endTime = new Date(res.data.endTime)
      this.outfitsDetail = res.data
    })
  }
  getGroupList() {
    OutfitClassifyApi.getAllgroupList().then((res) => {
      this.groupList = res.data
    })
  }
  deleteItem(productIndex) {
    this.outfitsDetail.promotionOutfitProducts.splice(productIndex, 1)
  }
  picChange(e) {
    console.log('e: ', e)
    this.outfitsDetail.pictureUrl = e[0].url
  }
  onProductChange(e) {
    console.log('e: ', e)
    let { id } = this.$route.params
    e.forEach((t) => {
      this.outfitsDetail.promotionOutfitProducts.push({
        promotionOutfitId: id ? id : '',
        productId: t.id,
        pictureUrl: t.pictureUrl,
        productName: t.name,
        brandName: t.brandName,
        productCode: t.code,
        marketPrice: t.marketPrice,
        price: t.price,
        displayOrder: 0,
      })
    })
  }
  save() {
    console.log(this.outfitsDetail)
    let form: any = this.$refs.formValidate
    form.validate((valid) => {
      if (valid) {
        let { id } = this.$route.params
        if (this.outfitsDetail.promotionOutfitProducts && this.outfitsDetail.promotionOutfitProducts.length) {
          if (this.outfitsDetail.promotionOutfitProducts.length < 2) {
            this.$Notice.warning({
              desc: '请至少选择2件套装商品',
            })
            return
          }
        } else {
          this.$Notice.warning({
            desc: '请至少选择2件套装商品',
          })
          return
        }
        if (id) {
          OutfitApi.updateProductOutfit(id, this.outfitsDetail).then((res) => {
            this.$Notice.success({
              desc: '更新成功',
            })
            this.$router.go(-1)
          })
        } else {
          OutfitApi.postProductOutfit(this.outfitsDetail).then((res) => {
            this.$Notice.success({
              desc: '创建成功',
            })
            this.$router.go(-1)
          })
        }
      }
    })
  }
}
